import { isStreamIQ } from '@/shared/lib'

export async function getGetFetchBootstrapsModule() {
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/shared/lib/fetchBootstraps')
            return module.fetchBootstraps
        } catch (error) {
            console.warn(
                'fetchBootstraps module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
}
